import { render, staticRenderFns } from "./Farm.vue?vue&type=template&id=4b650e69&lang=html&"
import script from "./Farm.vue?vue&type=script&lang=js&"
export * from "./Farm.vue?vue&type=script&lang=js&"
import style0 from "./Farm.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports